import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';

import { ampApiBaseUrlInterceptor } from '../interceptors/amp-api-base-url.interceptor';

export function provideAmpHttp(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(withInterceptors([ampApiBaseUrlInterceptor])),
  ]);
}
